import { TextLink } from "@vds/buttons";
import { Body } from "@vds/typography";
import React, { useEffect, useState } from "react";
import SearchInput from "../../utility/Utils";
import { DropdownSelect } from "@vds/selects";
import { useSelector } from "react-redux";
import { getRoles } from "../../../model/roleService";
import SitesDropdownFilter from "./SitesDropdownFilter";
import "./filterComponent.css";
import {
  FILTER_TEXT_RESET_FILTER,
  FILTER_TEXT_APPLY,
  FILTER_TEXT_CANCEL,
  FILTER_TEXT_SEARCH_PREFIX,
  FILTER_TEXT_SITES,
  FILTER_TAB_LOCATION,
  FILTER_TAB_LOCATION_LOWERCASE,
  PAGE_IDENTIFIER_CAMERAS_TAB,
  PAGE_IDENTIFIER_COMPANION_TAB,
  PAGE_IDENTIFIER_ALERTS,
  PAGE_IDENTIFIER_EVENTS,
} from "../../constants/filterConstants";

const FilterComponentUI = ({
  filters,
  filterCategories,
  selectedOptions,
  handleFilterChange,
  handleApply,
  handleCancel,
  handleReset,
  dataList,
  pageIdentifier,
  activeFilterTab,
  onTabChange,
  companionSiteId = null,
}) => {
  const [activeTab, setActiveTab] = useState(activeFilterTab || filterCategories[0]);
  const [searchQuery, setSearchQuery] = useState(""); // Add this state to track user input
  const [selectedSites, setSelectedSites] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [rolesList, setRolesList] = useState([]); // To store the fetched roles
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const [sitesDropdownFlow, setSitesDropdownFlow] = useState(false);

  useEffect(() => {
    setSiteList(siteTagList?.sites);
  }, []);

  useEffect(() => {
    if (activeFilterTab) {
      setActiveTab(activeFilterTab);
    }
  }, [activeFilterTab]);

  let filteredSites = siteList || [];
  const handleSiteToggle = (selectedSiteId, filteredSites) => {
    const selectedSite = filteredSites.find(
      (site) => site.id === selectedSiteId
    );
    if (selectedSite) {
      setSelectedSites(selectedSite);
      setIsValid(true);
    } else {
      setSelectedSites([]);
      setIsValid(false);
    }
  };
  const [selectedRolesReset, setSelectedRolesReset] = useState(false);

  const handleResetCheck = () => {
    setSelectedRolesReset(true);
    setSelectedSites([]);
    setSelectedRoles([]);
    setSitesDropdownFlow(false);
  };

  const getIsValidDataReset = (data) => {
    setSelectedRolesReset(data);
  };

  return (
    <>
      {/* Backdrop overlay for mobile */}
      <div
        className="filter-modal-backdrop"
        onClick={(e) => {
          // Only close if clicking the backdrop itself (not bubbled from child elements)
          if (e.target === e.currentTarget) {
            e.stopPropagation();
            handleCancel();
          }
        }}
      />
      <div className="filter-modal-container">
        {/* left tabs */}
        <div className="filter-tabs-sidebar">
        {filterCategories?.map((tab) => (
          <div
            key={tab}
            className={activeTab === tab ? "filter-tab-active" : ""}
          >
            <button
              className="filter-tab-button"
              data-testid="filterCategoriesTab"
              onClick={() => {
                setActiveTab(tab);
                setSitesDropdownFlow(false);
                if (onTabChange) {
                  onTabChange(tab);
                }
              }}
            >
              <Body size="medium">{tab}</Body>
            </button>
            <hr className="filter-tab-separator" />
          </div>
        ))}
      </div>

      {/* right side content */}
      <div className="filter-content-wrapper">
        <div className="filter-scrollable-content">
          {/* Sticky header section */}
          <div className="filter-sticky-header">
            <div className="filter-reset-header">
              <TextLink
                surface="light"
                size="small"
                data-testid="resetFilterButton"
                onClick={() => {
                  handleReset();
                  handleResetCheck();
                }}
              >
                {FILTER_TEXT_RESET_FILTER}
              </TextLink>
            </div>
            <Body size="large" bold>
              {activeTab !== FILTER_TAB_LOCATION ? activeTab : FILTER_TEXT_SITES}
            </Body>
            <div className="filter-search-container">
              {pageIdentifier === PAGE_IDENTIFIER_CAMERAS_TAB ||
              pageIdentifier === PAGE_IDENTIFIER_COMPANION_TAB ||
              pageIdentifier === PAGE_IDENTIFIER_ALERTS ||
              pageIdentifier === PAGE_IDENTIFIER_EVENTS ? (
                activeTab?.toLowerCase().includes(FILTER_TAB_LOCATION_LOWERCASE) && (
                  <SitesDropdownFilter
                    filters={filters}
                    activeTab={activeTab}
                    selectedOptions={selectedOptions}
                    handleFilterChange={handleFilterChange}
                    dataList={dataList}
                    setSitesDropdownFlow={setSitesDropdownFlow}
                    getSelectedRolesReset={selectedRolesReset}
                    getIsValidDataReset={getIsValidDataReset}
                    pageIdentifier={pageIdentifier}
                    companionSiteId={companionSiteId}
                  ></SitesDropdownFilter>
                )
              ) : (
                <SearchInput
                  placeholder={`${FILTER_TEXT_SEARCH_PREFIX}${activeTab?.toLowerCase()}`}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              )}
            </div>
          </div>
          {/* Scrollable checkbox list */}
          {!sitesDropdownFlow && !(activeTab?.toLowerCase().includes(FILTER_TAB_LOCATION_LOWERCASE) && (pageIdentifier === PAGE_IDENTIFIER_CAMERAS_TAB || pageIdentifier === PAGE_IDENTIFIER_COMPANION_TAB || pageIdentifier === PAGE_IDENTIFIER_ALERTS || pageIdentifier === PAGE_IDENTIFIER_EVENTS)) && (
            <div className="filter-checkbox-list-outer">
              <div className="filter-checkbox-list-scrollable">
                {filters?.[activeTab]
                  ?.filter((option) => {
                    return option?.name
                      ?.toString()
                      ?.toLowerCase()
                      ?.includes(searchQuery?.toLowerCase());
                  })
                  ?.map((option, index) => (
                    <div key={index} className="filter-checkbox-item">
                      <label className="filter-checkbox-label">
                        <input
                          type="checkbox"
                          checked={
                            activeTab === FILTER_TAB_LOCATION
                              ? false // For now, always show unchecked for Location since it's handled by SitesDropdownFilter
                              : selectedOptions?.[activeTab]?.includes(option.value)
                          }
                          onChange={() => handleFilterChange(activeTab, option)}
                          className="filter-checkbox-input"
                          data-testid="filterTabCheckbox"
                        />

                        <Body size="medium">{option.name}</Body>
                      </label>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
        <div className="filter-button-container">
          <button
            className="filter-apply-btn"
            onClick={handleApply}
            data-testid="filterTabApplyButton"
          >
            {FILTER_TEXT_APPLY}
          </button>
          <button
            className="filter-cancel-btn"
            onClick={handleCancel}
            data-testid="filterTabCancelButton"
          >
            {FILTER_TEXT_CANCEL}
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default FilterComponentUI;